import cn from 'classnames';
import React, {FC, useEffect} from 'react';
import {useSelector} from 'react-redux';

import {AppButton} from '../../../../../components/Button';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import ModalTypes from '../../../../../enums/app/modalTypes';
import analyticsService from '../../../../../services/analyticsService';
import connectivityService from '../../../../../services/device/connectivityService';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import appRouterService from '../../../../../services/route/appRouterService';
import {hideModalAction} from '../../../../../state/ducks/modal';
import {selectIotDeviceType} from '../../../../../state/selectors/iotDevice';
import {makeSelectVisibleGlobalModal} from '../../../../../state/selectors/modal';
import {dispatch} from '../../../../../state/store';

interface IProps {
    hideNotification: () => void;
}

const QsgDevicePairedNotification: FC<IProps> = (props) => {
    const {hideNotification} = props;
    const isBle = connectivityService.isBle();
    const type = useSelector(selectIotDeviceType);
    const isVisibleQSGPopup = useSelector(makeSelectVisibleGlobalModal(ModalTypes.QUICK_START_GUIDE_POPUP));

    useEffect(() => {
        analyticsService.pushSuccessPairingConnectingDeviceNotificationEvent(type, isBle);
    }, []);

    const localizedStrings = getLocalizedStrings();
    const notificationText = localizedStrings.formatString(localizedStrings[localizationKeys.QSG_NOTIFICATION_TEXT]);
    const buttonText = localizedStrings[localizationKeys.QSG_NOTIFICATION_BUTTON];

    const onButtonClick = () => {
        hideNotification();

        if (isVisibleQSGPopup || !type) {
            dispatch(hideModalAction(ModalTypes.QUICK_START_GUIDE_POPUP));
            dispatch(hideModalAction(ModalTypes.UWM_UNAVAILABILITY));
        } else {
            appRouterService.forwardToDeviceSettingsPage();
        }
    };

    return (
        <>
            <span className={cn({'pr-1': notificationText})}>{notificationText}</span>
            <AppButton tertiary onClick={onButtonClick} className='inline-block'>
                {buttonText}
            </AppButton>
        </>
    );
};

export default QsgDevicePairedNotification;
